import {types} from "mobx-state-tree";
import PublishDomainManager from "src/managers/publishdomain/publishDomainManager";
import Prefix from "./Prefix";
import { flow, getEnv } from "mobx-state-tree";
import { protocolConstants } from "../utils/constants";

const DomainSharedModel = types.model('domainSharedModel',{
  groupUuids: types.optional(types.array(types.string),[]),
  tenantUuids: types.optional(types.array(types.string),[]),
});

export const PublishDomain = types.model('PublishDomain',{
  uuid: types.identifier,
  domain: types.maybe(types.string),
  name: types.maybe(types.string),
  label:types.maybe(types.string),
  isDefault: types.maybe(types.boolean),
  isGlobal: types.maybe(types.boolean),
  defaultProtocol: types.maybeNull(types.enumeration('Protocol', [protocolConstants.HTTP, protocolConstants.HTTPS])),
  owner: types.maybe(types.string),
  shared: types.optional(DomainSharedModel,{}),
  prefixes: types.optional(types.array(Prefix),[]),
  selectedPrefix: types.maybeNull(types.safeReference(Prefix)),
  //subgroup??
}).volatile((self)=>({
  notifySelect: () => {},
})).actions((self) => ({
  setConsumer(f){
    self.notifySelect = f
  },
  setPrefixes: flow(function* (params){
    const publishDomainManager = getEnv(self).publishDomainManager;
    const prefixes = yield publishDomainManager.fetchPrefixes(self.uuid, params);
    if(prefixes?.results && prefixes?.results?.length > 0){
      for(let i = 0; i < prefixes.results.length; i++){
        prefixes.results[i].label = prefixes.results[i].prefix;
      }
      // add none option - use domain UUID to make it unique
      prefixes.results.unshift({label: "No Prefix", uuid:`no-prefix-${self.uuid}`, domainAttachedTo: self.domain, createdAt:"", updatedAt:"", prefix:""})
      self.prefixes = prefixes.results;
      self.selectedPrefix = self.getFirstPrefix();
    } else {
      // When no prefixes exist, show domain-specific message
      self.prefixes = [{label: "This domain: No prefixes", uuid:`no-prefix-${self.uuid}`, domainAttachedTo: self.domain, createdAt:"", updatedAt:"", prefix:""}];
      self.selectedPrefix = self.getFirstPrefix();
    }
  }),
  selectPrefix: function (e) {
    self.selectedPrefix = e;
    self.notifySelect(e);
  },
  getFirstPrefix: function () {
    if(self.prefixes.length > 0){
      return self.prefixes[0];
    }
    return {};
  }
})).views((self) => ({
  get hasAvailablePrefixes() {
    // Check if there are actual prefixes (not just the "no prefixes" placeholder)
    // A domain has available prefixes if:
    // 1. Has more than 1 prefix (meaning real prefixes + "No Prefix" option), OR
    // 2. Has 1 prefix with a non-empty prefix value (meaning only real prefixes, no "No Prefix" option)
    return self.prefixes.length > 1 ||
           (self.prefixes.length === 1 && self.prefixes[0].prefix !== "");
  },

  get hasNoPrefixes() {
    return !self.hasAvailablePrefixes;
  }
}));
